import { StringDecoder } from 'string_decoder'
import {ProducerType} from './producerClass';

export class CnxProperties {
  audioRecvCodec: string
  endpoint: string
  pin: boolean
  sublayout: string
  videoRecvCodec: string
  videoSendCodec: string
  videoRecvHeight: string
  videoRecvWidth: string
  videoSendHeight: number
  videoSendWidth: number
}

export class EndpointDetail {
  browser: string
  os: string
  flashVersion: string
  epType: string
}

export class People {

  isSelf: boolean
  id: string
  name: string
  role: string
  status: string
  joinTime: number
  timezone: string
  noParticipantDetectionDate: number
  inParticipantRoster: boolean

  endpointGUID: string
  seamGuid: string
  csrc: number
  streamIndex: number
  url: string
  type: ProducerType
  camera: string
  blurRange: number

  audioMute: boolean
  audioHardMute: boolean
  localAudioMute: boolean
  remoteAudioMute: boolean

  videoMute: boolean
  videoHardMute: boolean
  localVideoMute: boolean

  shareScreen: boolean
  speaking: boolean
  voiceProcessing: boolean

  callQuality: number
  contentShareMute: boolean

  properties: CnxProperties
  endpointDetail: EndpointDetail

  constructor(json?: any) {
    if (json) {
      for(const [key, value] of Object.entries(json)) {
        this[key] = value
      }
      this.timezone = 'America/New_York'

      console.log('constructor PEOPLE isSelf=', this.isSelf , this.name )
    }
  }
}